import React from "react";
import { generateRandomString } from "../../../../../utils";
import { FlowState, QueryGroup, QueryItem } from "../@types";
import { FLOW_STATES } from "../consts";
import { getLabelFromQueryItems } from "./convertQueryToString";
import { nextFlowState } from "./flowControlUtils";

export const createNewOption = ({
  label,
  value,
  complexValue,
  flowState,
  useValueAsItemKey = false
}: {
  value: string;
  label?: React.ReactNode;
  flowState: FlowState;
  useValueAsItemKey?: boolean;
  complexValue?: Array<string>;
}): QueryItem => ({
  label: label ?? value.trim(),
  complexValue,
  value: value.trim(),
  itemKey: useValueAsItemKey ? value : generateRandomString(),
  state: flowState
});

export const createNewGroupOption = ({
  value,
  keyword,
  isEditing,
  grouped
}: {
  value: string;
  keyword?: string;
  isEditing?: boolean;
  grouped?: Array<QueryItem>;
}): QueryGroup => ({
  value: grouped ? getLabelFromQueryItems(grouped) : value.trim(),
  itemKey: generateRandomString(), // so that the react-select can have values with the same label
  label: grouped ? getLabelFromQueryItems(grouped) : value.trim(),
  keyword: keyword ?? value.trim(),
  grouped:
    grouped ??
    (value
      ? [
          createNewOption({
            value,
            flowState: FLOW_STATES.ALL_KEYWORDS
          })
        ]
      : undefined),
  isEditing
});

export const createOptionsArrayWithComplexValue = ({
  currentGroup,
  optionToAdd,
  flowState
}: {
  currentGroup?: QueryGroup;
  optionToAdd: QueryGroup;
  flowState: FlowState;
}) => {
  if (optionToAdd.complexValue) {
    const newOptions: Array<QueryItem> = [];
    let lastFlowState = flowState;
    const lastElementOfLastGroup = currentGroup?.grouped?.at(-1);
    if (
      optionToAdd.complexValue.length > 1 &&
      lastElementOfLastGroup?.state === FLOW_STATES.ALL_KEYWORDS
    ) {
      newOptions.push(
        createNewOption({
          value: "[",
          flowState: lastFlowState
        })
      );
      lastFlowState = nextFlowState(lastFlowState, "[");
    }

    optionToAdd.complexValue.forEach(singleValue => {
      newOptions.push(
        createNewOption({
          value: singleValue,
          flowState: lastFlowState
        })
      );
      lastFlowState = nextFlowState(lastFlowState, singleValue);
    });

    return newOptions;
  }

  return [
    createNewOption({
      value: optionToAdd.value,
      flowState
    })
  ];
};
